import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "vp-hero" }
const _hoisted_2 = {
  key: 0,
  id: "main-title"
}
const _hoisted_3 = {
  key: 1,
  class: "vp-hero-description"
}
const _hoisted_4 = {
  key: 2,
  class: "vp-hero-actions"
}

import VPAutoLink from '@theme/VPAutoLink.vue'
import { useDarkMode } from '@theme/useDarkMode'
import type { FunctionalComponent } from 'vue'
import { computed, h } from 'vue'
import {
  ClientOnly,
  usePageFrontmatter,
  useSiteLocaleData,
  withBase,
} from 'vuepress/client'
import type { DefaultThemeHomePageFrontmatter } from '../../shared/index.js'


export default /*@__PURE__*/_defineComponent({
  __name: 'VPHomeHero',
  setup(__props) {

const frontmatter = usePageFrontmatter<DefaultThemeHomePageFrontmatter>()
const siteLocale = useSiteLocaleData()
const isDarkMode = useDarkMode()

const heroText = computed(() => {
  if (frontmatter.value.heroText === null) {
    return null
  }
  return frontmatter.value.heroText || siteLocale.value.title || 'Hello'
})
const tagline = computed(() => {
  if (frontmatter.value.tagline === null) {
    return null
  }

  return (
    frontmatter.value.tagline ||
    siteLocale.value.description ||
    'Welcome to your VuePress site'
  )
})
const heroImage = computed(() => {
  if (isDarkMode.value && frontmatter.value.heroImageDark !== undefined) {
    return frontmatter.value.heroImageDark
  }
  return frontmatter.value.heroImage
})
const heroAlt = computed(
  () => frontmatter.value.heroAlt || heroText.value || 'hero',
)
const heroHeight = computed(() => frontmatter.value.heroHeight ?? 280)

const actions = computed(() => {
  if (!Array.isArray(frontmatter.value.actions)) {
    return []
  }

  return frontmatter.value.actions.map(({ type = 'primary', ...rest }) => ({
    type,
    ...rest,
  }))
})

const HomeHeroImage: FunctionalComponent = () => {
  if (!heroImage.value) return null

  const img = h('img', {
    class: 'vp-hero-image',
    src: withBase(heroImage.value),
    alt: heroAlt.value,
    height: heroHeight.value,
  })

  if (frontmatter.value.heroImageDark === undefined) {
    return img
  }

  // wrap hero image with <ClientOnly> to avoid ssr-mismatch
  // when using a different hero image in dark mode
  return h(ClientOnly, () => img)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(HomeHeroImage),
    (heroText.value)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(heroText.value), 1))
      : _createCommentVNode("", true),
    (tagline.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(tagline.value), 1))
      : _createCommentVNode("", true),
    (actions.value.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actions.value, (action) => {
            return (_openBlock(), _createBlock(VPAutoLink, {
              key: action.text,
              class: _normalizeClass(["vp-hero-action-button", [action.type]]),
              config: action
            }, null, 8, ["class", "config"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})